var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"dount_chart"}},[_c('div',{staticClass:"chart-tooltip"},[(_vm.tooltipData)?[_c('span',[_vm._v(_vm._s(_vm.tooltipData.name))])]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }